var isDebug;
function getUrlVars() {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}
function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return ""; 
}
function setReferralCookie() {
  var ref = getUrlVars()[qParameter];
  if(ref != null) {
    setCookie(cookieName, ref);
  } else {
    ref = getCookie(cookieName);
    if(ref == ""){
      ref = defaultWebalias;
      setCookie(cookieName, defaultWebalias);
    }
  }
  //if(location.host == "lordeandbelle.com" && !window.location.href.includes("clearcart=true") && !window.location.href.includes("?token=")){
    //var obj = {};
    //var path = location.pathname.split("?")[0];
    //console.log(path);
    //var url = "/" + ref + path;
    //if(url.includes("/zh/")) {
      //url = "/zh/" + ref + path
    //}
    //if(url.includes("/es/")) {
      //url = "/es/" + ref + path
    //}
    //url = url.replace("//", "/");
    //window.history.pushState(obj, document.title, url);
  //}
}
function setCookie(cName, value) {
    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
    document.cookie = cName + "=" + value + expires + "; path=/";
}
function setSessionCookie(cName, value) {
    document.cookie = cName + "=" + value + "; path=/";
}
function setReferralInfo() {
  var announcement = document.getElementById("website-greeting");
  var cookieValue = getCookie(cookieName);
  if(announcement != undefined){
    $.ajax({
      url: appUrl + '/shopify/referral/GetName?webalias=' + cookieValue,
      type: "GET",
      success: function(response){
        if (response.success) {
            announcement[0].innerHTML = "Welcome to " + response.json + "'s shop";
        } else {
            announcement[0].innerHTML = "Welcome to " + response.json;
        }
      }
    });
  }
}
function delay(callback, ms) {
  var timer = 0;
  return function() {
    var context = this, args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      callback.apply(context, args);
    }, ms || 0);
  };
}
function setEnrollerSearch() {
  $('[data-role="search-enroller"]').on("click", function(){
    $(".enroller-search-container").show();
    $("#enroller-id-box").hide();
  });
  $(window).click(function() {
    $('#enrollerSearchResult').hide();
  });
  $('#searchEnrollerInput').on("focus", function(event){
    if($(this).val() != "")
    {
      $('#enrollerSearchResult').show();
    }
  });
  $('#searchEnrollerInput').click(function(event){
    event.stopPropagation();
  });
  $('#enrollerSearchResult').click(function(event){
    event.stopPropagation();
  });
  
  $('#searchEnrollerInput').keyup(delay(function (e) {
    var query = $(this).val();
    if(query == "") {
      $("#enrollerSearchResult").hide();
    } else {
      searchForEnroller(query);
    }
  }, 500));
  var enrollersearch = document.getElementById("enrollerSearch")
  if(enrollersearch != undefined) {
    if(getCookie(cookieName).toLowerCase() == defaultWebalias) {
      $(".enroller-search-container").show();
      $("#enrollerSearchLabel").hide();
      $("#orphan-enroller").show();
      $("#enroller-id-box").hide();
    } else {
      $.ajax({
        url: appUrl + '/api/context/GetEnroller?webalias=' + getCookie(cookieName),
        type: "GET",
        headers: {
          "sitetoken": exigoApiToken
        },
        success: function(response){
          var source = document.getElementById("enroller-id-template").innerHTML;
          var template = Handlebars.compile(source);
          $("#enrollerInfo").html(template(response));
          if(response.CustomerTypeID == 6) {
            $(".join-menuitem").hide();
          }
        }
      });
    }
  }
}
function searchForEnroller(query){
  setTimeout(function(){
    $("#enrollerSearchResult").show();
    var currentWebalias = getCookie("refId");
    $.ajax({
      url: appUrl + '/api/context/EnrollerSearch?query=' + query,
      type: "GET",
        headers: {
          "sitetoken": exigoApiToken
        },
      success: function(response){
        if(response.length == 0) {
          $("#enrollerSearchResult").html('<span class="enroller-no-result">Translation missing: en.enrollersearch.general.no_results</span>');
        } else {
          var source = document.getElementById("search-result-template").innerHTML;
          var html= "";
          $.each(response, function(i,item){
            var url = "";
            if(location.href.includes("ref=")) {
              url = location.href.replace("ref=" + currentWebalias, "ref=" + item.WebAlias);
            } else {
              url = location.href + "?ref=" + item.WebAlias;
            }
            item["Link"] = url;
          });
          var template = Handlebars.compile(source);
          $("#enrollerSearchResult").html(template(response));
        }
      }
    });
  }, 500);
}
function addUrlParameter(url, param) {
  if(url.includes("?")){
    url = url + '&';
  } else {
    url = url + '?';
  }
  url = url + param;
  return url;
}
function removeURLParameter(url, parameter) {
  if(url.includes("?")) {
    var urlparts = url.split('?');   
    if (urlparts.length >= 2) {
        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);
        for (var i = pars.length; i-- > 0;) {   
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
                pars.splice(i, 1);
            }
        }
        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
  }
  return url;
}
function addReferralToUrl() {
    var refId = getCookie(cookieName);
    if (refId != "") {
        var links = document.querySelectorAll("a");

        for (var i = 0; i < links.length; i++) {
            var link = links[i].getAttribute("href");
            var linkClass = links[i].getAttribute("class");
          if(link != undefined && (linkClass != "ProductMeta__ShareItem" && linkClass != "inpage_link")){
            if(!link.includes("office.lordeandbelle.com"))
            {
              var href = removeURLParameter(link, qParameter)
              links[i].href = addUrlParameter(href, qParameter + "=" + refId);
            }
          } else if (linkClass == "ProductMeta__ShareItem"){
            var newLink = link.replace("//lordeandbelle.com/", "//lordeanbelle.com/" + refId + "/");
          }
        }
    }
}
function getCartJSON() {
    return fetch('/cart.js')
        .then(function (response) {
            return response.json();
        })
        .then(function (json) {
          json.items.map(function(item) { 
              delete item.product_description; 
              return item; 
          });
          var referral = getCookie(cookieName);
          var jsonstring = JSON.stringify(json);
          var cart = jsonstring.replace("'s", "s");
          var url = appUrl + '/' + referral;
          var form = $('<form action="' + url + '" method="post">' +
            "<input type='text' name='token' value='" + exigoSilentLoginToken + "' />" +
            "<input type='text' name='cart' value='" + JSON.stringify(json) + "' />" +
            '<input type="text" name="countryCode" value="' + countryCode + '" />' +
            '<input type="text" name="shopUrl" value="' + shopifyDomain + '" />' +
            '<input type="text" name="cultureCode" value="' + cultureCode + '" />' +
            '</form>');
          $('body').append(form);
          form.submit();
        })
        .catch(function (error) {
            console.error('Error retreiving cart: ', error);
            return "";
        });
}
function createCheckout() {
    return fetch('/cart.js')
        .then(function (response) {
            return response.json();
        })
        .then(function (json) {
          json.items.map(function(item) { 
              delete item.product_description; 
              return item; 
          });
          var referral = getCookie(cookieName);
          var jsonstring = JSON.stringify(json);
          var cart = jsonstring.replace("'s", "s");
          var url = appUrl + '/' + referral + "/ShopifyCheckout/CreateDraftOrder";
          var form = $('<form action="' + url + '" method="post">' +
            "<input type='text' name='token' value='" + exigoSilentLoginToken + "' />" +
            "<input type='text' name='cart' value='" + JSON.stringify(json) + "' />" +
            '<input type="text" name="countryCode" value="' + countryCode + '" />' +
            '<input type="text" name="shopUrl" value="' + shopifyDomain + '" />' +
            '<input type="text" name="cultureCode" value="' + cultureCode + '" />' +
            '</form>');
          $('body').append(form);
          form.submit();
        })
        .catch(function (error) {
            console.error('Error retreiving cart: ', error);
            return "";
        });
}
async function getCartJsonString(){
  const cart = await fetch('/cart.js');
  const json = await cart.json();
  json.items.map(function(item) { 
      delete item.product_description; 
      return item; 
  });
  return json;        
}
function GoToCheckout() {
  hasPack = false;
  return fetch('/cart.js')
    .then(function (response) {
        return response.json();
    })
    .then(function (json) {
      console.log(json);
      for(let i = 0; i < json.items.length; i++) {
        let obj = json.items[i];
        if(obj.properties != null) {
          if(obj.properties.ordertype == "enrollmentpack"){
            hasPack = true;
          }
          if(obj.properties.ordertype == "autoorder"){
            hasPack = true;
          }
        }
      }
      var referral = getCookie(cookieName);
      if(!hasPack && (!isCustomer || (isCustomer && customertype == 1))){
        window.location = "/checkout"
      } else {
        getCartJSON();
      }
    })
    .catch(function (error) {
        console.error('Error retreiving cart: ', error);
        return "";
    });
}
function insertNotesCreateCustomerForm() {
  var form = $("#create_customer");
  if (form != undefined) {
    var cartToken = getCookie(cartTokenCookieName);
    if (cartToken != "") {
      var tokenInput = '<input type="hidden" name="customer[note][carttoken]" value="' + cartToken + '">';
      form.prepend(tokenInput)
    }
    var refId = getCookie(cookieName);
    var refInput = '<input type="hidden" name="customer[note][referral]" value="' + refId + '">';
    form.prepend(refInput)
  }
}
function clearCart(){
  if(window.location.href.includes("clearcart=true")) {
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      success: function(){
        window.location = window.location.href.replace("clearcart=true", "");
      },
      dataType: 'json'
    });
  }
  else if(window.location.href.includes("pages/clearcart")){
    $.ajax({
    type: "POST",
    url: '/cart/clear.js',
    success: function(){
      window.location = appUrl + "/" + getCookie(cookieName) + "/shopifycheckout/ordercomplete";
    },
    dataType: 'json'
  });
  }
}
function addToCart(subscribeAndSave){
  var pricetype = $("#pricetype").val();
  var item = $('#add-to-cart-form').serialize();
  $.ajax({
    type: 'POST', 
    url: '/cart/add.js',
    dataType: 'json', 
    data: $('#add-to-cart-form').serialize(),
    success: function(){
      if(subscribeAndSave == true && exigoSilentLoginToken == ""){
        $("#ordertype").val("autoorder");
         pricetype = $("#pricetype").val();
          $.ajax({
            type: 'POST', 
            url: '/cart/add.js',
            dataType: 'json', 
            data: $('#add-to-cart-form').serialize(),
            success: function(){
              window.location = "/cart"; 
            }
           });
        } else {
            window.location = "/cart"; 
        }
      }
   });
}
function Checkforenrollmentkit() {
  var hasPack = false;
  return fetch('/cart.js')
    .then(function (response) {
        return response.json();
    })
    .then(function (json) {
      for(let i = 0; i < json.items.length; i++) {
        let obj = json.items[i];
          if(obj.properties.ordertype == "enrollmentpack"){
            hasPack = true;
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              dataType: 'json',
              data: {
                  quantity: 0,
                  id: obj.id
              },
              success: function (data){
                addToCart(false);
              }
            });
          }
      }
      if(!hasPack) {
        addToCart();
      }
    })
    .catch(function (error) {
        console.error('Error retreiving cart: ', error);
        return "";
    });
}
function setDebugCookie() {
  var debug = getUrlVars()["debugsession"];
  if(debug != null) {
    setCookie("debugsession", debug);
  } else {
    var debugCookie = getCookie("debugsession");
    if(debugCookie == ""){
      setCookie("debugsession", "0");
    }
  }
}
function getProductPrices(priceType, sku) {
    $.ajax({
      url: appUrl + '/api/context/getProductPrice?pricetype=' + priceType + '&sku=' + sku,
      type: "GET",
        headers: {
          "sitetoken": exigoApiToken
        },
      success: function(response){
        $(".exigo-product-price-" + sku).html("$" + response.Data.price);
        $(".preferred-product-price-" + sku).html("$" + response.Data.PreferredPrice);
        $(".wholesale-product-price-" + sku).html("$" + response.Data.Wholesale);
        $(".retail-product-price-" + sku).html("$" + response.Data.Retail);
        $(".cv-" + sku).html("$" + response.Data.CV);
        $(".bv-" + sku).html("$" + response.Data.BV);
        $(".qv-" + sku).html("$" + response.Data.QV);
      }
    });
}
var orderTotalNew = 0;
var autoOrderTotalNew = 0;
async function calculateCart(priceType, cartType) {
  const cart = await getCartJsonString();
  orderTotalNew = 0;
  autoOrderTotalNew = 0;
    for(var i in cart.items){
      var item = cart.items[i];
      if(cartType == 'order') {
          if(item.properties.ordertype == "enrollmentpack" || item.properties.ordertype == "order"){
            setCartPrice(priceType, item, cartType);
          } 
        }
      
      if(cartType == 'autoorder'){
        if (item.properties.ordertype == "autoorder") {
            setCartPrice(priceType, item, cartType);
        }
      }
    }
}
function setCartPrice(priceType, item, cartType){
  $.ajax({
    url: appUrl + '/api/context/calculateCartItem?pricetype=' + priceType + "&sku=" + item.sku + "&quantity=" + item.quantity,
    type: "GET",
      headers: {
        "sitetoken": exigoApiToken
      },
    success: function(response){
      if(cartType == "order"){
        orderTotalNew = orderTotalNew + response.Data.price;
        $(".exigo-price-" + item.sku).html("$" + response.Data.priceString);
        $(".cart-total").html("$" + orderTotalNew.toFixed(2));
      } else {
          autoOrderTotalNew = autoOrderTotalNew + response.Data.price;
          $(".exigo-autoorder-price-" + item.sku).html("$" + response.Data.priceString);
          $(".autoorder-total").html("$" + autoOrderTotalNew.toFixed(2));
      }
    }
  });
}
function setEventListeners(){
  $('#exigo-cart').on("submit", function (e) {
        e.preventDefault();
        if(isDebug > 0) {
          GoToCheckout();
        } else {
          getCartJSON();
        }
    });
    $('[data-role="add-to-autoorder"]').on("click", function (e) {
        if(exigoSilentLoginToken != ""){
          $("#ordertype").val("autoorder");
          $(".ProductForm").submit();
        } else {
          $("#ordertype").val("order");
          addToCart(true);
        } 
    });
    $('[data-role="add-to-order"]').on("click", function (e) {
      var orderType = $("#ordertype").val();
      if(orderType == "enrollmentpack"){
        Checkforenrollmentkit();
      } else {
        $("#ordertype").val("order");
        addToCart(false);
      }
    });
  
    //Create Customer logic
    jQuery(function () {
        jQuery('#create_customer').submit(function (event) {
            event.preventDefault();
            var data = jQuery(this).serialize();

            //create new account
            jQuery.post('/account', data)
                .done(function (data) {
                    var logErrors = jQuery(data).find('.errors').text();

                    //if there are errors show them in the html form
                    if (logErrors != "" && logErrors != 'undefined') {
                        jQuery('#create_customer .errors').html(logErrors);
                        jQuery('#create_customer .errors').show();

                        //if account creation is successful show checkout page
                    } else {
                        document.location.href = '/account';
                    }
                }).fail(function () { console.log('error'); });
            return false;
        });
    });
  
  $("#newsletter-form-submit").on("click", function(){
    var email = $("#newsletter-input").val();
    $("#newsletter-popup-alert").hide();
    $.ajax({
      url: appUrl + '/' + getCookie(cookieName) + '/shopifycheckout/CreateNewsletterCustomer',
      type: "POST",
      data: { email: email },
      success: function(response){
          console.log(response);
        if(response.success){
          $("#newsletter-popup-alert").addClass("Alert--success");
          $("#newsletter-popup-alert").removeClass("Alert--error");
          $("#newsletter-popup-alert").html(response.message);
        } else {
          $("#newsletter-popup-alert").removeClass("Alert--success");
          $("#newsletter-popup-alert").addClass("Alert--error");
          $("#newsletter-popup-alert").html(response.message);
        }
        $("#newsletter-popup-alert").show();
      }
    })
  });
   $("#newsletter-form-submit-footer").on("click", function(){
    var email = $("#newsletter-input-footer").val();
    $("#newsletter-footer-alert").hide();
    $.ajax({
      url: appUrl + '/' + getCookie(cookieName) + '/shopifycheckout/CreateNewsletterCustomer',
      type: "POST",
      data: { email: email },
      success: function(response){
        if(response.success){
          $("#newsletter-footer-alert").addClass("Alert--success");
          $("#newsletter-footer-alert").removeClass("Alert--error");
          $("#newsletter-footer-alert").html(response.message);
        } else {
          $("#newsletter-footer-alert").removeClass("Alert--success");
          $("#newsletter-footer-alert").addClass("Alert--error");
          $("#newsletter-footer-alert").html(response.message);
        }
        $("#newsletter-footer-alert").show();
      }
    })
  });
  var target = document.querySelector('.recently-viewed')

  // Create an observer instance.
  var observer = new MutationObserver(function(mutations) {
      var $products = $(".price-container");
      $products.each( function(){
        getProductPrices($(this).data("pricetype"), $(this).data("sku"));                     
      });
  });
  
  // Pass in the target node, as well as the observer options.
  observer.observe(target, {
      attributes:    true,
      childList:     true,
      characterData: true
  });
}
function resolveDebugSession(){
  isDebug = getCookie("debugsession");
  if(isDebug == "1") {
    $(".dev-box").show();
    appUrl = "https://lordeandbelle.azurewebsites.net";
  } else if (isDebug == 2) {
    appUrl = "https://localhost:44376";
    $(".dev-box").show();
  } else {
  }
}
document.addEventListener("DOMContentLoaded", function (e) {
  setDebugCookie();
  resolveDebugSession();
  clearCart();
  setReferralCookie();
  insertNotesCreateCustomerForm();
  setReferralInfo();
  addReferralToUrl();
  setEnrollerSearch();
  currentLocationNoRef = removeURLParameter(location.href, qParameter);
  setEventListeners();
  getCartJsonString();
});



